import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "../styles/global.css";

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Clear storage
    localStorage.removeItem("authToken");
    localStorage.removeItem("config_id");
    localStorage.removeItem("user_id");
    localStorage.removeItem("user");
    localStorage.removeItem("name");
    localStorage.removeItem("role");

    toast.success("Logout Successfully");
 

    const timer = setTimeout(() => {
      navigate("/home", { replace: true });
    }, 300);

    return () => clearTimeout(timer);
  }, [navigate]);

  return null; // No UI needed
};

export default Logout;
